import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction, checkAnswerAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const NotEnteredAnswerChecker = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const checkAnswer = () => { dispatch( checkAnswerAction() ) };

  const hide = () => {
    setAnsweringQuestions( { isShowNotEnteredAnswerPopup : false } );
  };

  return cloneElement( props.children || <Fragment />, {
    onConfirm : checkAnswer,
    onHide : hide
  } );

};

export default NotEnteredAnswerChecker;
